export default __webpack_public_path__ + "static/media/thumbnail.581607e2.png";